import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { APP_ROUTES } from './routes/app.routes';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { apolloProviderService } from '@core/graphql/graphql.config';
import { AUTH_CONFIG } from '@auth/consts/auth-config.const';
import { provideAuth } from 'angular-auth-oidc-client';
import { MATERIAL_PROVIDERS } from '@shared/modules/material.providers';
import { BROWSER_PROVIDERS } from '@shared/consts/browser-providers.const';

export const appConfig: ApplicationConfig = {
  providers: [
    apolloProviderService,
    provideAuth(AUTH_CONFIG),
    provideHttpClient(withFetch()),
    provideRouter(APP_ROUTES),
    provideZoneChangeDetection({ eventCoalescing: true }),
    ...MATERIAL_PROVIDERS,
    ...BROWSER_PROVIDERS,
  ],
};
